/** The editable task fields TaskFieldRows can render, and each surface's order. */

export type TaskFieldKey = 'status' | 'dueDate' | 'assignee';

/** Slideout Overview: where the task is, when it is due, who owns it. */
export const OVERVIEW_TASK_FIELD_ORDER: readonly TaskFieldKey[] = [
  'status',
  'dueDate',
  'assignee',
];

/**
 * Task card, set by the product owner: who owns it, where it is, when it is
 * due. A card is scanned in a list, where the person is the first thing you
 * look for.
 */
export const CARD_TASK_FIELD_ORDER: readonly TaskFieldKey[] = [
  'assignee',
  'status',
  'dueDate',
];
